import { SortDirection, TableSort } from "../tables/table";
import { DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum ForecastingSystemView {
  ALL = "all",
}

export const sortDefault: TableSort = {
  direction: SortDirection.ASC,
  key: "title",
};

const defaultColumns = [
  { key: "selected", width: 48, hidden: false },
  { key: "title", width: 300, hidden: false },
  { key: "daysOfStockRemaining", width: 150, hidden: false },
  { key: "daysUntilReorder", width: 150, hidden: false },
  { key: "unitsToOrder", width: 150, hidden: false },
  { key: "totalQuantity", width: 150, hidden: false },
  { key: "incomingShipments", width: 150, hidden: false },
  { key: "moq", width: 100, hidden: true },
  { key: "leadTime", width: 150, hidden: false },
  { key: "buffer", width: 150, hidden: false },
  { key: "inventoryValue", width: 150, hidden: false },
  { key: "supplier", width: 150, hidden: false },
  { key: "vendor", width: 150, hidden: false },
  { key: "sold30Days", width: 130, hidden: false },
  { key: "sold60Days", width: 130, hidden: false },
  { key: "sold90Days", width: 130, hidden: false },
  { key: "sold180Days", width: 130, hidden: false },
  { key: "sold365Days", width: 130, hidden: false },
  { key: "forecast30Days", width: 150, hidden: false },
  { key: "forecast60Days", width: 150, hidden: false },
  { key: "forecast90Days", width: 150, hidden: false },
  { key: "forecast180Days", width: 150, hidden: false },
  { key: "forecast365Days", width: 150, hidden: false },
  { key: "totalAvailable", width: 120, hidden: true },
  { key: "totalReserved", width: 120, hidden: true },
  { key: "totalCommitted", width: 120, hidden: true },
];

export const StaticSystemViews: Record<
  ForecastingSystemView,
  viewTypes["forecasting"]
> = {
  [ForecastingSystemView.ALL]: {
    table: "forecasting",
    name: ForecastingSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 0,
    isNotEditable: true,
  },
};

export function friendlyViewName(view: viewTypes["forecasting"]) {
  switch (view.name) {
    case ForecastingSystemView.ALL:
      return "All";
    default:
      return view.name;
  }
}
